import { render, staticRenderFns } from "./ProductsPage.vue?vue&type=template&id=473623e0&scoped=true"
import script from "./ProductsPage.vue?vue&type=script&lang=js"
export * from "./ProductsPage.vue?vue&type=script&lang=js"
import style0 from "./ProductsPage.vue?vue&type=style&index=0&id=473623e0&prod&scoped=true&lang=css"
import style1 from "./ProductsPage.vue?vue&type=style&index=1&id=473623e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473623e0",
  null
  
)

export default component.exports